module.exports = __webpack_public_path__ + "4befa7bd0fcbd95876057e91f784bd90.MP3";